import { useEffect } from 'react';
import { Gift, Home, ListChecks, Settings, Sparkles, UserRoundCog } from 'lucide-react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth';
import { Logo } from './Logo';

const nav = [
  { to: '/', label: 'Trang chủ', Icon: Home, end: true },
  { to: '/log', label: 'Ghi điểm', Icon: Sparkles },
  { to: '/rewards', label: 'Quà', Icon: Gift },
  { to: '/manage', label: 'Quản lý', Icon: ListChecks }
];

export function AppShell() {
  const { me, selectedChild, selectedChildId, setSelectedChildId } = useAuth();
  const location = useLocation();
  const hideHeader = ['/survey', '/install'].includes(location.pathname);

  useEffect(() => {
    const requested = new URLSearchParams(location.search).get('child');
    if (requested && me?.children.some((child) => child.id === requested)) {
      setSelectedChildId(requested);
    }
  }, [location.search, me?.children, setSelectedChildId]);

  return (
    <div className="app-frame">
      {!hideHeader && (
        <header className="app-header">
          <Logo compact />
          <div className="header-actions">
            {me && me.children.length > 0 && (
              <label className="child-picker">
                <span aria-hidden="true">👦</span>
                <select
                  aria-label="Chọn hồ sơ con"
                  value={selectedChildId}
                  onChange={(event) => setSelectedChildId(event.target.value)}
                >
                  {me.children.map((child) => (
                    <option key={child.id} value={child.id}>{child.nickname}</option>
                  ))}
                </select>
              </label>
            )}
            <NavLink to="/manage" className="header-icon" aria-label="Quản lý hồ sơ bé">
              <UserRoundCog size={21} />
            </NavLink>
            <NavLink to="/install" className="header-icon" aria-label="Cài đặt và thông báo">
              <Settings size={21} />
            </NavLink>
          </div>
        </header>
      )}
      <main className={hideHeader ? 'app-content app-content--full' : 'app-content'}>
        <Outlet context={{ selectedChild }} />
      </main>
      {!hideHeader && (
        <nav className="bottom-nav" aria-label="Điều hướng chính">
          {nav.map(({ to, label, Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => isActive ? 'active' : ''}>
              <Icon size={23} strokeWidth={2.2} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      )}
    </div>
  );
}
